import styled from '@emotion/styled'
import React from 'react'
import { useProduct } from '../../__product/useProduct'

type ContainerProps = {
    paddingBottom?: number
    paddingTop?: number
    marginBottom?: number
    marginTop?: number
}

const StyledContainer = styled('div')<ContainerProps>(
    {
        display: 'flex',
        justifyContent: 'center',
    },
    (props) => ({
        paddingBottom: props.paddingBottom,
        paddingTop: props.paddingTop,
        marginBottom: props.marginBottom,
        marginTop: props.marginTop,
    }),
)

export const StyledButtonContainer: React.FC = (props) => {
    const product = useProduct()
    return product === 'thewest' ? (
        <StyledContainer paddingBottom={10} paddingTop={10} marginBottom={18}>
            {props.children}
        </StyledContainer>
    ) : (
        <StyledContainer paddingBottom={20} paddingTop={20}>
            {props.children}
        </StyledContainer>
    )
}
StyledButtonContainer.displayName = 'StyledButtonContainer'
